import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=08678b5c&scoped=true&"
import script from "./AppForm.vue?vue&type=script&lang=ts&"
export * from "./AppForm.vue?vue&type=script&lang=ts&"
import style0 from "./AppForm.vue?vue&type=style&index=0&id=08678b5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08678b5c",
  null
  
)

export default component.exports